module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-09.c1a1f53f.jpg";